const PERSIAN_DIGITS = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"] as const;

export function toPersianDigits(value: number): string {
  return String(value)
    .split("")
    .map((char) => PERSIAN_DIGITS[Number(char)] ?? char)
    .join("");
}
